export default __webpack_public_path__ + "static/media/coinFour.61174faf.png";